<template>
    <i class="scratch-icon icon-gold">g</i>
</template>

<script>
    export default {
        name: 'IconGold'
    }
</script>

<style scoped>
@import "../assets/scratch.css";
.icon-gold {
    background: url("../assets/icons/gold.png") no-repeat;
}
</style>